import BookingHeader from "./BookingHeader.jsx";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getCurrentProductURI } from "app/pages/FicheProduit/ficheProduitSelector";

const mapStateToProps = state => {
	return {
		ficheProduitUri: getCurrentProductURI(state),
		resolution: state.resolution,
		brand: state.brand.code,
	};
};

export default connect(mapStateToProps)(withRouter(BookingHeader));
